export default "__VITE_ASSET__VohYWtzc__"